import { getStoreGetter } from '@assets/scripts/store/config';
import { IS_DEV } from '@assets/scripts/helpers';
import usePermission from '@assets/scripts/composables/usePermission';

export const names = {
	MODIFIED: 'modified',
	CAN_BE_EDITED: 'canBeEdited',
	CAN_BE_SAVED: 'canBeSaved',
    CAN_BE_PUBLISHED: 'canBePublished',
	SCRIPT_ACTIVE: 'scriptActive',
	CURRENT_SCRIPT: 'currentScript',
	SHOW_CREATE_NEW: 'showCreateNew',
	DATA_LOSS_POSSIBLE_HOOK: 'dataLossPossible',
};

export default {
	[names.MODIFIED]: ({ modified }) => {
		return modified;
	},
	[names.CAN_BE_EDITED]: ({ canBeModified }) => {
		// can be edited if it has never been published yet
		return canBeModified;
	},
	[names.CAN_BE_SAVED]: ({ canBeModified, modified }) => {
		// can be saved only if it has never
		// been published yet, and it has been modified
		return canBeModified && modified;
	},
    [names.CAN_BE_PUBLISHED]: ({ canBeModified, modified }) => {
		// if a script has not been published yet, or it has been
		// modified, it can be published, IF current user has correct permissions
		return (
			(canBeModified || modified) &&
			usePermission('Upsert', 'ScriptBuilder')
		);
	},
	[names.SCRIPT_ACTIVE]: ({ currentScript }) => {
		return Object.keys(currentScript).length > 0;
	},
	[names.CURRENT_SCRIPT]: ({ currentScript }) => {
		return currentScript;
	},
	[names.SHOW_CREATE_NEW]: ({ showCreateNew }) => {
		return showCreateNew;
	},
	[names.DATA_LOSS_POSSIBLE_HOOK]: (
		state,
		getters,
		rootState,
		rootGetters
	) => {
		return (
			rootGetters[getStoreGetter('MODIFIED', 'SB')]
		);
	},
	debug: (state) => {
		// output whole state for debugging since Vue Devtools plugin
		// not (always) shows the updated state of the store, but it
		// does show the correct value of all getters
		return IS_DEV ? state : {};
	},
};
